import { Expose, Transform } from 'class-transformer';
import {
  IsBoolean,
  IsDate,
  IsNotEmpty,
  IsOptional,
  IsString,
  IsUUID,
  ValidateNested,
} from 'class-validator';
import { PatientSummaryQueryDto } from '../patient-summary-query.dto';
import { TransformPropertiesToClass } from '../dto.util';

export class BiopsySearchQueryResult {
  @Expose()
  @IsUUID()
  @IsNotEmpty()
  biopsy_id: string;

  @Expose()
  @IsDate()
  @IsNotEmpty()
  created_date: Date;

  @Expose()
  @IsString()
  @IsOptional()
  reference: string;

  @Expose()
  @IsUUID()
  @IsNotEmpty()
  lesion_id: string;

  @Expose()
  @TransformPropertiesToClass('patient_', PatientSummaryQueryDto)
  @ValidateNested()
  patient: PatientSummaryQueryDto;

  @Expose()
  @IsString()
  @IsOptional()
  biopsy_type_name: string;

  @Expose()
  @IsBoolean()
  @Transform(({ value }) => !!value)
  diagnosed: boolean;

  @Expose()
  @IsUUID()
  @IsOptional()
  histopathological_diagnosis_id?: string;

  @Expose()
  @IsUUID()
  @IsOptional()
  clinical_diagnosis_id?: string;
}
